import SearchWidget from 'govbr.frontend.policy/components/SearchWidget/SearchWidget';

export default SearchWidget;
